<template>
  <svg aria-hidden="true">
    <use :xlink:href="symbolId" :fill="color" />
  </svg>
</template>

<script setup name="SvgIcon" lang="ts">
  import { computed } from 'vue'

  type IProps = {
    prefix: string
    name: string
    color: string
  }

  const props = withDefaults(defineProps<Partial<IProps>>(), {
    prefix: 'icon',
    name: '',
    color: '#333',
  })

  const symbolId = computed(() => `#${props.prefix}-${props.name}`)
</script>
